<template>
    <modal data-parent="body">
        <div slot="header">
            <button type="button" class="close" @click.prevent="closeModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div slot="body">
            <div class="intro">
                <h4>Please enter a note to remove the listing</h4>
            </div>
            <form @submit.prevent="submitForm">
                <div class="form-column">
                    <div class="form-group">
                        <div class="form-item">
                            <textarea
                                class="form-control v2-styles"
                                placeholder="Your comment..."
                                :disabled="states.submitting"
                                v-model="formData.note"
                                required
                            ></textarea>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-green btn-block" :disabled="states.submitting">
                        <template v-if="states.submitting">
                            <i class="fa fa-circle-o-notch fa-spin"/> Submitting&hellip;
                        </template>
                        <template v-else>Remove listing</template>
                    </button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal';
    import ModalBase from '../ModalBase.vue';

    export default {
        name: 'remove-listing-modal',

        components: {
            Modal,
        },

        mixins: [ModalBase],

        props: {
            space: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        data() {
            return {
                formData: {
                    note: null,
                },
                states: {
                    submitting: false,
                    errors: [],
                    validation_errors: [],
                },
            }
        },

        mounted() {
            window.bus
                .$off('showRemoveListingModal')
                .$on('showRemoveListingModal', () => {
                    this.formData.note = null;
                    this.states.validation_errors = [];
                    this.states.submitting = false;
                    this.showModal();
                });
        },

        methods: {
            /**
             * Disable the space and mark as 'follow up'
             */
            submitForm() {
                this.states.errors = [];
                this.states.submitting = true;

                $.ajax({
                    type:  'post',
                    dataType: 'json',
                    url:   this.$laroute.route('hatchly.spaces.remove-listing', { id: this.space.id }),
                    data:  this.formData,
                    success(response) {
                        swal({
                            title: response.message,
                            type: 'success',
                        }, () => {
                            return window.location.reload();
                        });

                    },
                    error(response) {
                        return swal({
                            title: response.responseJSON.message,
                            type: 'error',
                        });
                    },
                    complete: () => {
                        this.states.submitting = false;
                    },
                })
            },

            /**
             * Close the modal
             */
            closeModal() {
                $('#remove-listing-modal').modal('hide');
            },
        },
    }
</script>
